import { render, staticRenderFns } from "./OverviewPage.vue?vue&type=template&id=da45b750&scoped=true"
import script from "./OverviewPage.vue?vue&type=script&lang=js"
export * from "./OverviewPage.vue?vue&type=script&lang=js"
import style0 from "./OverviewPage.vue?vue&type=style&index=0&id=da45b750&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da45b750",
  null
  
)

export default component.exports